function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { forwardRef } from '@chakra-ui/react';
import { NavLink } from "../Nav";
import { jsx as _jsx } from "react/jsx-runtime";
export var NavbarLink = forwardRef((props, ref) => /*#__PURE__*/_jsx(NavLink, _extends({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  position: "relative",
  py: 3,
  textStyle: "textlink-large-medium"
}, props, {
  ref: ref
})));
//# sourceMappingURL=NavbarLink.js.map